// extracted by mini-css-extract-plugin
module.exports = {"transition":"App_transition__3oWZn","bodyLeft":"App_bodyLeft__GpIGO","bodyRight":"App_bodyRight__W5hL_","bodyFixed":"App_bodyFixed__2M1ZK","appContainer":"App_appContainer__n6z8c"};